import React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import { X } from 'lucide-react'; // Import X icon for close button

export function ToastProvider({ children }) {
  return (
    <ToastPrimitive.Provider swipeDirection="up">
      {children}
      <ToastPrimitive.Viewport className="fixed bottom-0 left-0 right-0 flex flex-col items-center w-full px-4 pb-8 md:pb-6 gap-2 z-[9999] outline-none" />
    </ToastPrimitive.Provider>
  );
}

export function Toast({ title, description, open, onOpenChange }) {
  return (
    <ToastPrimitive.Root
      open={open}
      onOpenChange={onOpenChange}
      className="w-full max-w-[calc(100vw-2rem)] md:max-w-3xl bg-gradient-to-r from-purple-600 via-pink-500 to-blue-500 text-white rounded-lg shadow-lg p-3 md:p-4 relative data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-bottom-full data-[state=open]:slide-in-from-bottom-full"
    >
      <div className="flex items-start justify-between gap-3 md:gap-4">
        <div className="flex-1">
          {title && (
            <ToastPrimitive.Title className="text-base md:text-lg font-semibold mb-0.5 md:mb-1">
              {title}
            </ToastPrimitive.Title>
          )}
          {description && (
            <ToastPrimitive.Description className="text-xs md:text-sm opacity-90">
              {description}
            </ToastPrimitive.Description>
          )}
        </div>
        <ToastPrimitive.Close className="rounded-lg p-1 md:p-1.5 hover:bg-white/20 transition-colors">
          <X className="w-4 h-4 md:w-5 md:h-5" />
        </ToastPrimitive.Close>
      </div>
    </ToastPrimitive.Root>
  );
} 